import { render } from "./TemplatesOverview.vue?vue&type=template&id=2a9bbf7c"
import script from "./TemplatesOverview.vue?vue&type=script&lang=js"
export * from "./TemplatesOverview.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/342/dashboard.jumpfeed.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
